export const localStorageKeys = {
    darkMode: "dark-mode",
    doNotShowEditIntro: "skip-edit-explainer-dialog",
    discoveryThemeBannerDismissed: "discovery-page-theme-banner-dismissed",
    tekkrEmailBotDisclaimerDismissed: "tekkr-email-bot-disclaimer-dismissed",
    tutorialEditSegmentDismissed: "tutorial-edit-segment-dismissed",
    onboardingPlaybookProcessExplainerDismissed: "onboarding-playbook-process-explainer-dismissed",
    hideNavigationTooltips: "hide-navigation-tooltips",
    googleDriveTopBannerDismissed: "google-drive-top-banner-dismissed",
    googleDriveChatBannerDismissed: "google-drive-chat-banner-dismissed",
    googleDriveSyncJobId: "google-drive-sync-job-id",
};
